






























import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import QRCode from "qrcodejs2";
import { GetToken, GetQRcode } from "@/request/projects";
import Copy from "@/components/copy.vue";
import Pagination from "@/components/paginaiton.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../sjzx/modules/zbsjk/components/nav-left.vue";
@Component({
  components: {
    Copy,
    Pagination,
    MainHeader,
    LeftNav,
  },
})
export default class ProjectCrfPublish extends Vue {
  private title: any = "";
  private qr: any = null;
  private id: any = "";
  private isSetTime: any = false;
  private startTime: any = null;
  private endTime: any = null;
  private isSupportAdd: any = false;
  private website: any = "";
  private imgurl: any = "";
  private copySuccess(e) {
    this.$message({
      type: "success",
      message: "复制成功！",
    });
  }

  private onError(e) {
    this.$message({
      type: "error",
      message: "复制失败！",
    });
  }
  /**
   * @description 下载二维码
   */
  private downLoadImg() {
    const a = document.createElement("a");
    a.href = this.imgurl;
    a.setAttribute("download", "QRcode");
    a.click();
  }
  private _arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return "data:image/jpeg;base64," + window.btoa(binary);
  }
  private getQRCode() {
    GetToken(this).then((res: any) => {
      const params = {
        scene: this.id,
        page: "pages/index/index",
        access_token: res,
      };
      GetQRcode(this, params).then((data: any) => {
        const qr = this._arrayBufferToBase64(data);
        this.imgurl = qr;
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.template_id) {
      this.$message.error("参数有误");
      this.$router.back();
      return;
    }
    this.id = this.$route.query.template_id;
    // this.website =
    //   "http://10.17.3.28:8080/#/share/patient?template_id=" + this.id;
    // this.title = this.$route.query.title;
    // this.qr = new QRCode(this.$refs.qrCodeDiv, {
    //   text: this.website,
    //   width: 140,
    //   height: 140,
    //   colorDark: "#333333",
    //   colorLight: "#ffffff",
    //   correctLevel: QRCode.CorrectLevel.L,
    // });

    this.getQRCode();
  }
}
